import http from './http';
import {AUTHORITY_BASE} from './paths';
import {withPerm} from './perm';

const BASE_URL = AUTHORITY_BASE;

export const getAuthorities = withPerm(async () => (await http.get(BASE_URL)).data, 'GET', `${BASE_URL}`);
export const getAuthority = withPerm(async (id) => (await http.get(`${BASE_URL}/${id}`)).data, 'GET', `${BASE_URL}/{id}`);
export const createAuthority = withPerm(async (payload) => (await http.post(BASE_URL, payload, { headers:{'Content-Type':'application/json'} })).data, 'POST', `${BASE_URL}`);
export const updateAuthority = withPerm(async (id, payload) => (await http.put(`${BASE_URL}/${id}`, payload, { headers:{'Content-Type':'application/json'} })).data, 'PUT', `${BASE_URL}/{id}`);
export const deleteAuthority = withPerm(async (id) => (await http.delete(`${BASE_URL}/${id}`)).data, 'DELETE', `${BASE_URL}/{id}`);
export const deleteAuthorityBatch = withPerm(async (ids=[]) => (await http.delete(BASE_URL, { data: ids })).data, 'DELETE', `${BASE_URL}`);
